import React from "react";
import { Link } from "react-router-dom";
import logoUCW from "../assets/img/logo.webp";
import FollowAs from "./footer/FollowAs";
import SupportedTechnologies from "./footer/SupportedTechnologies";

const Footer: React.FC = () => (
  <footer
    className="
      bg-[var(--color-secondary-dark)]
      text-[var(--color-text-light)]
      pt-12 pb-8 px-6 sm:px-8 lg:px-12
      shadow-[0_-2px_8px_rgba(0,0,0,0.2)]
      border-t-[4px] border-transparent
      [border-image:radial-gradient(circle,_var(--color-primary),_var(--color-secondary),_rgb(240,240,240))_1]
      transition-all duration-300 ease-in-out"
  >
    <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10 items-center">
      {/* Branding */}
      <div className="flex flex-col items-center md:items-start text-center md:text-left space-y-4">
        <img
          src={logoUCW}
          alt="UC Waves Logo"
          className="w-24 md:w-28 object-contain"
        />
        <h4 className="text-xl font-bold tracking-wide">UC Waves</h4>
        <p className="text-sm opacity-80 leading-relaxed max-w-xs">
          Empowering the future of decentralized applications.
        </p>
        <FollowAs />
      </div>

      {/* Navigation */}
      <div className="flex flex-col sm:flex-row justify-between gap-8">
        <nav aria-labelledby="footer-company">
          <h5 id="footer-company" className="font-semibold text-lg mb-4">
            Company
          </h5>
          <ul className="space-y-2">
            <li>
              <Link
                to="/about"
                className="hover:text-[var(--color-primary-light)] transition"
              >
                About Us
              </Link>
            </li>
            <li>
              <Link
                to="/blog"
                className="hover:text-[var(--color-primary-light)] transition"
              >
                Blog
              </Link>
            </li>
            <li>
              <Link
                to="/comming-soon"
                className="hover:text-[var(--color-primary-light)] transition"
              >
                Careers
              </Link>
            </li>
          </ul>
        </nav>

        <nav aria-labelledby="footer-legal">
          <h5 id="footer-legal" className="font-semibold text-lg mb-4">
            Legal
          </h5>
          <ul className="space-y-2">
            <li>
              <Link
                to="/terms"
                className="hover:text-[var(--color-primary-light)] transition"
              >
                Terms of Service
              </Link>
            </li>
            <li>
              <Link
                to="/privacy-policy"
                className="hover:text-[var(--color-primary-light)] transition"
              >
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link
                to="/legal-notice"
                className="hover:text-[var(--color-primary-light)] transition"
              >
                Legal Notice
              </Link>
            </li>
          </ul>
        </nav>
      </div>

      {/* Technologies */}
      <div className="flex flex-col items-center md:items-end">
        <SupportedTechnologies />
      </div>
    </div>

    {/* Bottom line */}
    <div className="mt-10 border-t border-[var(--color-secondary-muted)] pt-4 text-center text-xs opacity-60">
      © 2025 NextGenWaves. All rights reserved.
    </div>
  </footer>
);

export default Footer;
